<div class="main-wrapper">
  <div class="all-charts-container">
    <div class="curing-legends"></div>
    <div id="curing-graph"></div>
    <div class="rng_slider_container">
      <div class="rng_sliders_control" *ngIf="showRangeSlider">
        <input
          id="fromSlider"
          type="range"
          value="0"
          min="0"
          max="100"
          #fromSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
        <input
          id="toSlider"
          type="range"
          value="100"
          min="0"
          max="100"
          #toSlider
          (input)="updateChartVisibleRange(fromSlider.value, toSlider.value)"
        />
      </div>
    </div>
  </div>
  <div class="chart-controls">
    <div class="controls-top">
      <div class="help-btn" (click)="toggleHelpOverlay()">
        <img src="../../assets/Help/Help.svg" alt="" class="help-btn-img" />
      </div>
      <ul>
        <li
          (click)="setRollOver(true)"
          [class]="[rolloverModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link1"></a>
          <img
            src="../../assets/Help/Inspect.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setPan(true)"
          [class]="[zoomPanModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link2"></a>
          <img
            src="../../assets/Help/Drag.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li
          (click)="setZoom(true)"
          [class]="[rubberBandZoomModifier?.isEnabled ? 'highlighted' : '']"
        >
          <a [routerLink]="" class="link3"></a>
          <img
            src="../../assets/Help/Zoom.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-top">
      <ul>
        <li (click)="zoomOut()">
          <a [routerLink]="" class="link4"></a>
          <img
            src="../../assets/Help/Zoom out.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li (click)="toggleRangeSlider()">
          <a [routerLink]="" class="link5"></a>
          <img
            src="../../assets/Help/Show Hide Zoom Control.svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
      </ul>
    </div>
    <div class="controls-spacer"></div>
    <div class="controls-bottom">
      <ul>
        <li (click)="addMarker()">
          <a [routerLink]="" class="link6"></a>
          <img
            src="../../assets/Help/Add Marker .svg"
            class="help-right"
            *ngIf="this.projectService.isHelpOverlayVisible"
          />
        </li>
        <li><a [routerLink]="" class="link7"></a></li>
      </ul>
    </div>
  </div>
</div>
